<div class="general_colum">
  <div class="row">
    <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
      <p class="text_headerr">Trámites Revocados.</p>
      <p class="text_header">Licencia para prestación de servicios en Seguridad y Salud en el Trabajo.</p>
    </div>
  </div>

  <form [formGroup]="revocatoriaForm">
    <div class="col-sm-9 col-md-9">
      <div class="entradas-de-texto-govco">
        <label for="observation" class="form-label">Observaciones a la revocatoria</label>
        <div class="container-input-texto-govco">
          <textarea formControlName="observation"
                    class="form-control"
                    rows="3"
                    id="observation"
                    [ngClass]="{'error': isTouchedField(revocatoriaForm, 'observation')}"
                    aria-describedby="observation-note"
          ></textarea>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="observations-note" role="alert" aria-live="assertive">
                      {{ getErrorMessage('observation') }}
          </span>
        </div>
      </div>
      <div class="col-12" style="margin: 5% 0 5% 0; text-align: right">
        <button type="button" class="btn-govco fill-btn-govco" (click)="revocar()" [disabled]="sending">Guardar</button>
      </div>
    </div>
  </form>

</div>
